import { FormInput } from "../../components/ui/Input/FormInput/FormInput";
import { AuthPageShell } from "./components/AuthPageShell";
import { AuthSubmitButton } from "./components/AuthSubmitButton";
import { AuthTextLink } from "./components/AuthTextLink";
import { AUTH_COPY, AUTH_ROUTES, FIELD_MAX_LENGTH } from "./constants/auth.constants";
import { buildPasswordResetState } from "./helpers/passwordResetRoute";
import { useForgotPasswordViewModel } from "./hooks/useForgotPasswordViewModel";
import { forgotPasswordFormRules } from "./validation/authFormRules";

/**
 * Redesigned forgot-password screen, gated behind `ENABLE_AUTH_UI_REDESIGN`.
 * Same request as the legacy `PasswordForgot` (`POST auth/forget-password`),
 * now with the submitted email carried over to the reset screen.
 */
const ForgotPasswordNew = () => {
  const { methods, onSubmit, isPending } = useForgotPasswordViewModel();

  return (
    <AuthPageShell
      eyebrow={AUTH_COPY.forgotPassword.eyebrow}
      title={AUTH_COPY.forgotPassword.title}
      subtitle={AUTH_COPY.forgotPassword.subtitle}
      methods={methods}
      onSubmit={onSubmit}
      footer={
        <>
          <AuthTextLink
            to={AUTH_ROUTES.resetPassword}
            state={buildPasswordResetState(false, "")}
          >
            Have an existing password? Reset it
          </AuthTextLink>
          <AuthTextLink to={AUTH_ROUTES.login}>Back to sign in</AuthTextLink>
        </>
      }
    >
      <FormInput
        control={methods.control}
        name="email"
        label="Email"
        type="email"
        placeholder="Enter email"
        maxLength={FIELD_MAX_LENGTH.email}
        disabled={isPending}
        data-testid="fp-email"
        {...forgotPasswordFormRules.email}
      />
      <AuthSubmitButton label={AUTH_COPY.forgotPassword.submitLabel} isPending={isPending} />
    </AuthPageShell>
  );
};

export default ForgotPasswordNew;
